import { InfoCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { BUTTON_TYPE, BUTTON_TYPE_VALUES } from "@/constants/Button";
import { ButtonsPropTypes } from "@/propTypes/Button.type";

const InfoButton = ({
  disabled,
  loading,
  type,
  onInfoSelect,
  buttonProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="informationButton"
      disabled={disabled}
      icon={<InfoCircleOutlined />}
      loading={loading}
      role="button"
      type={type ?? BUTTON_TYPE.DEFAULT}
      onClick={onInfoSelect}
      {...buttonProps}
    >
      {t("global:info")}
    </Button>
  );
};

InfoButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(BUTTON_TYPE_VALUES),
  onInfoSelect: PropTypes.func,
  buttonProps: ButtonsPropTypes,
};

export default InfoButton;
